const GOODLOT_WAREHOUSE_TIME_ZONE = 'America/Los_Angeles';

const GOODLOT_CUTOFF_HOUR = 14; // 2:00 PM PT

const GOODLOT_MIN_TRANSIT_BUSINESS_DAYS = 2;

const GOODLOT_MAX_TRANSIT_BUSINESS_DAYS = 4;

function getTimeZoneParts(date, timeZone) {

  const formatter = new Intl.DateTimeFormat('en-US', {

    timeZone,

    year: 'numeric',

    month: '2-digit',

    day: '2-digit',

    weekday: 'short',

    hour: '2-digit',

    minute: '2-digit',

    hourCycle: 'h23',

  });

  const parts = Object.fromEntries(

    formatter

      .formatToParts(date)

      .filter((part) => part.type !== 'literal')

      .map((part) => [part.type, part.value])

  );

  return {

    year: Number(parts.year),

    month: Number(parts.month),

    day: Number(parts.day),

    weekday: parts.weekday,

    hour: Number(parts.hour),

    minute: Number(parts.minute),

  };

}

function makeUtcDateFromCalendarParts({ year, month, day }) {

  return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));

}

function isWeekend(date) {

  const day = date.getUTCDay();

  return day === 0 || day === 6;

}

function nextBusinessDay(date) {

  const next = new Date(date);

  do {

    next.setUTCDate(next.getUTCDate() + 1);

  } while (isWeekend(next));

  return next;

}

function addBusinessDays(date, count) {

  const result = new Date(date);

  let added = 0;

  while (added < count) {

    result.setUTCDate(result.getUTCDate() + 1);

    if (!isWeekend(result)) {

      added += 1;

    }

  }

  return result;

}

function getGoodLotShipDate(now = new Date()) {

  const warehouseNow = getTimeZoneParts(now, GOODLOT_WAREHOUSE_TIME_ZONE);

  let shipDate = makeUtcDateFromCalendarParts(warehouseNow);

  if (isWeekend(shipDate)) {

    return nextBusinessDay(shipDate);

  }

  if (warehouseNow.hour >= GOODLOT_CUTOFF_HOUR) {

    shipDate = nextBusinessDay(shipDate);

  }

  return shipDate;

}

function formatArrivalRange(startDate, endDate) {

  const startMonth = new Intl.DateTimeFormat('en-US', {

    month: 'short',

    timeZone: 'UTC',

  }).format(startDate);

  const endMonth = new Intl.DateTimeFormat('en-US', {

    month: 'short',

    timeZone: 'UTC',

  }).format(endDate);

  const startDay = startDate.getUTCDate();

  const endDay = endDate.getUTCDate();

  if (startMonth === endMonth) {

    return `${startMonth} ${startDay}–${endDay}`;

  }

  return `${startMonth} ${startDay} – ${endMonth} ${endDay}`;

}

function updateDeliveryEstimate(root) {

  const target = root.querySelector('[data-goodlot-delivery-estimate]');

  if (!target) return;

  const shipDate = getGoodLotShipDate();

  const earliestArrival = addBusinessDays(

    shipDate,

    GOODLOT_MIN_TRANSIT_BUSINESS_DAYS

  );

  const latestArrival = addBusinessDays(

    shipDate,

    GOODLOT_MAX_TRANSIT_BUSINESS_DAYS

  );

  target.textContent =

    `Order today, estimated arrival ${formatArrivalRange(earliestArrival, latestArrival)}`;

}

function initGallery(root) {

  const mainMedia = root.querySelector('[data-goodlot-main-media]');

  const desktopMediaItems = [...root.querySelectorAll('[data-goodlot-desktop-media]')];

  const zoomButton = root.querySelector('.goodlot-pdp__zoom');

  const prevButton = root.querySelector('[data-goodlot-gallery-prev]');

  const nextButton = root.querySelector('[data-goodlot-gallery-next]');

  const thumbs = [...root.querySelectorAll('[data-goodlot-thumb]')];

  const mobileDots = [...root.querySelectorAll('[data-goodlot-mobile-dot]')];

  const mobileTrack = root.querySelector('[data-goodlot-mobile-track]');

  const mobileSlides = [...root.querySelectorAll('[data-goodlot-mobile-slide]')];

  const itemCount = desktopMediaItems.length || mobileSlides.length || thumbs.length;

  if (!mainMedia || itemCount === 0) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  let activeIndex = desktopMediaItems.findIndex((item) =>

    item.classList.contains('is-active')

  );

  if (activeIndex < 0) {

    activeIndex = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));

  }

  if (activeIndex < 0) activeIndex = 0;

  let dragStartX = 0;

  let dragStartY = 0;

  let dragDeltaX = 0;

  let dragging = false;

  let horizontalDrag = false;

  let pointerId = null;

// Meta in-app browser swipe guard.

// Prevents Facebook / Instagram's native horizontal navigation gesture

// from stealing intentional product-gallery swipes on mobile.

const isMetaInAppBrowser =

  /FBAN|FBAV|FBIOS|FB_IAB|Instagram/i.test(navigator.userAgent);

if (isMetaInAppBrowser && mobileTrack) {

  let metaTouchActive = false;

  let metaTouchStartX = 0;

  let metaTouchStartY = 0;

  let metaTouchAxis = null;

  const resetMetaTouch = () => {

    metaTouchActive = false;

    metaTouchStartX = 0;

    metaTouchStartY = 0;

    metaTouchAxis = null;

  };

  mainMedia.addEventListener(

    'touchstart',

    (event) => {

      if (!mobileQuery.matches || event.touches.length !== 1) {

        resetMetaTouch();

        return;

      }

      const target = event.target;

      // Do not interfere with buttons, links, zoom controls, or video players.

      if (

        target instanceof Element &&

        target.closest(

          'button, a, input, select, textarea, .goodlot-pdp__video-shell, video, iframe'

        )

      ) {

        resetMetaTouch();

        return;

      }

      const touch = event.touches[0];

      metaTouchActive = true;

      metaTouchStartX = touch.clientX;

      metaTouchStartY = touch.clientY;

      metaTouchAxis = null;

    },

    {

      passive: true,

      capture: true,

    }

  );

  mainMedia.addEventListener(

    'touchmove',

    (event) => {

      if (

        !metaTouchActive ||

        !mobileQuery.matches ||

        event.touches.length !== 1

      ) {

        return;

      }

      const touch = event.touches[0];

      const deltaX = touch.clientX - metaTouchStartX;

      const deltaY = touch.clientY - metaTouchStartY;

      const absX = Math.abs(deltaX);

      const absY = Math.abs(deltaY);

      // Wait for a small amount of movement before deciding intent.

      if (!metaTouchAxis) {

        if (absX < 8 && absY < 8) return;

        // Require clear horizontal intent before intercepting anything.

        if (absX > absY * 1.2) {

          metaTouchAxis = 'horizontal';

        } else if (absY > absX * 1.2) {

          metaTouchAxis = 'vertical';

        } else {

          return;

        }

      }

      // Horizontal gallery swipe:

      // stop the Meta WebView from treating it as native navigation.

      if (metaTouchAxis === 'horizontal' && event.cancelable) {

        event.preventDefault();

      }

    },

    {

      passive: false,

      capture: true,

    }

  );

  mainMedia.addEventListener('touchend', resetMetaTouch, {

    capture: true,

  });

  mainMedia.addEventListener('touchcancel', resetMetaTouch, {

    capture: true,

  });

}

  const normalizeIndex = (index) => {

    if (index < 0) return itemCount - 1;

    if (index >= itemCount) return 0;

    return index;

  };

  const getMediaType = (index) =>

    desktopMediaItems[index]?.dataset.goodlotMediaType ||

    mobileSlides[index]?.dataset.goodlotMediaType ||

    thumbs[index]?.dataset.goodlotMediaType ||

    'image';

  const getMediaPlayer = (index) =>

    desktopMediaItems[index]?.querySelector('iframe, video') ||

    mobileSlides[index]?.querySelector('iframe, video') ||

    null;

  const getMediaAspectRatio = (index) => {

    const mediaType = getMediaType(index);

    if (mediaType === 'image') return 1;

    const player = getMediaPlayer(index);

    if (!player) return 16 / 9;

    if (player instanceof HTMLVideoElement && player.videoWidth > 0 && player.videoHeight > 0) {

      return player.videoWidth / player.videoHeight;

    }

    const width = Number(player.getAttribute('width'));

    const height = Number(player.getAttribute('height'));

    if (Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0) {

      return width / height;

    }

    return 16 / 9;

  };

  const syncMediaAspectRatio = (index) => {

    const mediaType = getMediaType(index);

    const isVideo = mediaType === 'video' || mediaType === 'external_video';

    mainMedia.classList.toggle('is-video-active', isVideo);

    if (!isVideo) {

      mainMedia.style.removeProperty('--goodlot-active-media-ratio');

      return;

    }

    const applyRatio = () => {

      if (activeIndex !== index) return;

      const ratio = getMediaAspectRatio(index);

      if (Number.isFinite(ratio) && ratio > 0) {

        mainMedia.style.setProperty('--goodlot-active-media-ratio', String(ratio));

      }

    };

    applyRatio();

    const player = getMediaPlayer(index);

    if (player instanceof HTMLVideoElement && (!player.videoWidth || !player.videoHeight)) {

      player.addEventListener('loadedmetadata', applyRatio, { once: true });

    }

  };

  const getViewportWidth = () => mainMedia.getBoundingClientRect().width || 1;

  const setTrackPosition = (index, extraPixels = 0, animate = true) => {

    if (!mobileTrack) return;

    mobileTrack.classList.toggle('is-dragging', !animate);

    mobileTrack.style.transform =

      `translate3d(calc(${-index * 100}% + ${extraPixels}px), 0, 0)`;

  };

  const stopPlayersInside = (container) => {

    if (!container) return;

    container.querySelectorAll('video').forEach((video) => {

      try {

        video.pause();

      } catch (_) {

        // Safe fallback.

      }

    });

    // External YouTube/Vimeo embeds do not expose a native pause method here.

    // Reloading the iframe when leaving the slide stops playback without

    // introducing any additional player API dependency.

    container.querySelectorAll('iframe').forEach((iframe) => {

      const src = iframe.getAttribute('src');

      if (src) iframe.setAttribute('src', src);

    });

  };

  const stopMediaAtIndex = (index) => {

    stopPlayersInside(desktopMediaItems[index]);

    stopPlayersInside(mobileSlides[index]);

  };

  const syncDesktopMedia = (index) => {

    desktopMediaItems.forEach((item, itemIndex) => {

      const active = itemIndex === index;

      item.classList.toggle('is-active', active);

      item.setAttribute('aria-hidden', active ? 'false' : 'true');

    });

    const isImage = getMediaType(index) === 'image';

    if (!isImage) {

      mainMedia.classList.remove('is-zoomed');

    }

    if (zoomButton) {

      zoomButton.hidden = !isImage;

    }

    syncMediaAspectRatio(index);

  };

  const syncThumbs = (index, scrollThumb = true) => {

    if (thumbs.length === 0) return;

    thumbs.forEach((item, itemIndex) => {

      const active = itemIndex === index;

      item.classList.toggle('is-active', active);

      if (active) {

        item.setAttribute('aria-current', 'true');

      } else {

        item.removeAttribute('aria-current');

      }

    });

    const activeThumb = thumbs[index];

    if (scrollThumb && activeThumb && !mobileQuery.matches) {

      activeThumb.scrollIntoView({

        behavior: 'smooth',

        block: 'nearest',

        inline: 'center',

      });

    }

  };

  const syncDots = (index) => {

    mobileDots.forEach((dot) => {

      const dotIndex = Number(dot.dataset.goodlotDotIndex);

      const active = dotIndex === index;

      dot.classList.toggle('is-active', active);

      if (active) {

        dot.setAttribute('aria-current', 'true');

      } else {

        dot.removeAttribute('aria-current');

      }

    });

  };

  const showMedia = (requestedIndex, { animate = true, scrollThumb = true } = {}) => {

    const index = normalizeIndex(requestedIndex);

    if (index !== activeIndex) {

      stopMediaAtIndex(activeIndex);

    }

    activeIndex = index;

    mainMedia.dataset.goodlotActiveIndex = String(activeIndex);

    mainMedia.classList.remove('is-zoomed');

    syncDesktopMedia(activeIndex);

    syncThumbs(activeIndex, scrollThumb);

    syncDots(activeIndex);

    setTrackPosition(activeIndex, 0, animate);

  };

  thumbs.forEach((thumb, index) => {

    thumb.addEventListener('click', (event) => {

      event.preventDefault();

      event.stopPropagation();

      showMedia(index);

    });

    thumb.addEventListener('keydown', (event) => {

      if (event.key === 'ArrowLeft') {

        event.preventDefault();

        showMedia(activeIndex - 1);

      }

      if (event.key === 'ArrowRight') {

        event.preventDefault();

        showMedia(activeIndex + 1);

      }

    });

  });

  mobileDots.forEach((dot) => {

    dot.addEventListener('click', (event) => {

      event.preventDefault();

      event.stopPropagation();

      const dotIndex = Number(dot.dataset.goodlotDotIndex);

      if (Number.isFinite(dotIndex)) {

        showMedia(dotIndex);

      }

    });

  });

  prevButton?.addEventListener('click', (event) => {

    event.preventDefault();

    event.stopPropagation();

    showMedia(activeIndex - 1);

  });

  nextButton?.addEventListener('click', (event) => {

    event.preventDefault();

    event.stopPropagation();

    showMedia(activeIndex + 1);

  });

  const toggleZoom = () => {

    if (mobileQuery.matches) return;

    if (getMediaType(activeIndex) !== 'image') return;

    mainMedia.classList.toggle('is-zoomed');

  };

  zoomButton?.addEventListener('click', (event) => {

    event.preventDefault();

    event.stopPropagation();

    toggleZoom();

  });

  desktopMediaItems.forEach((item, itemIndex) => {

    const image = item.querySelector('.goodlot-pdp__main-image');

    image?.addEventListener('click', (event) => {

      if (mobileQuery.matches || itemIndex !== activeIndex) return;

      event.preventDefault();

      toggleZoom();

    });

  });

  // True touch-drag carousel for mobile:

  // the whole media strip follows the finger continuously, then snaps.

  mainMedia.addEventListener('pointerdown', (event) => {

    if (!mobileQuery.matches || !mobileTrack) return;

    // Keep native video and external player controls fully interactive.

    if (event.target.closest('.goodlot-pdp__video-shell, video, iframe')) return;

    if (event.pointerType === 'mouse' && event.button !== 0) return;

    dragging = true;

    horizontalDrag = false;

    pointerId = event.pointerId;

    dragStartX = event.clientX;

    dragStartY = event.clientY;

    dragDeltaX = 0;

    try {

      mainMedia.setPointerCapture(pointerId);

    } catch (_) {

      // Safe fallback.

    }

  });

  mainMedia.addEventListener('pointermove', (event) => {

    if (!dragging || event.pointerId !== pointerId || !mobileTrack) return;

    const deltaX = event.clientX - dragStartX;

    const deltaY = event.clientY - dragStartY;

    if (!horizontalDrag) {

      if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) return;

      // If the gesture is mostly vertical, let normal page scrolling win.

      if (Math.abs(deltaY) > Math.abs(deltaX)) {

        dragging = false;

        pointerId = null;

        return;

      }

      horizontalDrag = true;

    }

    dragDeltaX = deltaX;

    // Light resistance at the first/last slide rather than a hard stop.

    if (

      (activeIndex === 0 && dragDeltaX > 0) ||

      (activeIndex === itemCount - 1 && dragDeltaX < 0)

    ) {

      dragDeltaX *= 0.34;

    }

    setTrackPosition(activeIndex, dragDeltaX, false);

  });

  const endDrag = (event) => {

    if (!dragging || event.pointerId !== pointerId) return;

    const width = getViewportWidth();

    const threshold = Math.min(90, width * 0.18);

    const shouldAdvance = horizontalDrag && Math.abs(dragDeltaX) >= threshold;

    if (shouldAdvance) {

      if (dragDeltaX < 0 && activeIndex < itemCount - 1) {

        showMedia(activeIndex + 1);

      } else if (dragDeltaX > 0 && activeIndex > 0) {

        showMedia(activeIndex - 1);

      } else {

        setTrackPosition(activeIndex, 0, true);

      }

    } else {

      setTrackPosition(activeIndex, 0, true);

    }

    dragging = false;

    horizontalDrag = false;

    dragDeltaX = 0;

    pointerId = null;

  };

  mainMedia.addEventListener('pointerup', endDrag);

  mainMedia.addEventListener('pointercancel', () => {

    if (!mobileQuery.matches || !mobileTrack) return;

    setTrackPosition(activeIndex, 0, true);

    dragging = false;

    horizontalDrag = false;

    dragDeltaX = 0;

    pointerId = null;

  });

  mobileQuery.addEventListener?.('change', () => {

    stopMediaAtIndex(activeIndex);

    mainMedia.classList.remove('is-zoomed');

    setTrackPosition(activeIndex, 0, false);

  });

  showMedia(activeIndex, { animate: false, scrollThumb: false });

}

function initSourceInfoModal(root) {

  const modal = root.querySelector('[data-goodlot-source-info-modal]');

  const trigger = root.querySelector('[data-goodlot-source-info-open]');

  if (!modal || !trigger) return;

  const panel = modal.querySelector('[data-goodlot-source-info-panel]');

  const closeButtons = [...modal.querySelectorAll('[data-goodlot-source-info-close]')];

  let closeTimer = null;

  const getFocusableElements = () => {

    if (!panel) return [];

    return [

      ...panel.querySelectorAll(

        'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'

      ),

    ].filter((element) => !element.hidden && element.offsetParent !== null);

  };

  const openModal = () => {

    if (closeTimer) {

      window.clearTimeout(closeTimer);

      closeTimer = null;

    }

    modal.hidden = false;

    modal.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('goodlot-source-info-open');

    window.requestAnimationFrame(() => {

      modal.classList.add('is-open');

      window.requestAnimationFrame(() => {

        const focusable = getFocusableElements();

        (focusable[0] || panel)?.focus({ preventScroll: true });

      });

    });

  };

  const closeModal = () => {

    if (modal.hidden) return;

    modal.classList.remove('is-open');

    modal.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('goodlot-source-info-open');

    closeTimer = window.setTimeout(() => {

      modal.hidden = true;

      trigger.focus({ preventScroll: true });

      closeTimer = null;

    }, 250);

  };

  trigger.addEventListener('click', (event) => {

    event.preventDefault();

    event.stopPropagation();

    openModal();

  });

  closeButtons.forEach((button) => {

    button.addEventListener('click', closeModal);

  });

  modal.addEventListener('keydown', (event) => {

    if (event.key === 'Escape') {

      event.preventDefault();

      closeModal();

      return;

    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements();

    if (focusable.length === 0) return;

    const first = focusable[0];

    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {

      event.preventDefault();

      last.focus();

    } else if (!event.shiftKey && document.activeElement === last) {

      event.preventDefault();

      first.focus();

    }

  });

}

function initInspectionRecordModal(root) {

  const modal = root.querySelector('[data-goodlot-inspection-modal]');

  const trigger = root.querySelector('[data-goodlot-inspection-open]');

  if (!modal || !trigger) return;

  const panel = modal.querySelector('[data-goodlot-inspection-panel]');

  const closeButtons = [...modal.querySelectorAll('[data-goodlot-inspection-close]')];

  let closeTimer = null;

  const getFocusableElements = () => {

    if (!panel) return [];

    return [

      ...panel.querySelectorAll(

        'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'

      ),

    ].filter((element) => !element.hidden && element.offsetParent !== null);

  };

  const openModal = () => {

    if (closeTimer) {

      window.clearTimeout(closeTimer);

      closeTimer = null;

    }

    modal.hidden = false;

    modal.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('goodlot-inspection-modal-open');

    window.requestAnimationFrame(() => {

      modal.classList.add('is-open');

      window.requestAnimationFrame(() => {

        const focusable = getFocusableElements();

        (focusable[0] || panel)?.focus({ preventScroll: true });

      });

    });

  };

  const closeModal = () => {

    if (modal.hidden) return;

    modal.classList.remove('is-open');

    modal.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('goodlot-inspection-modal-open');

    closeTimer = window.setTimeout(() => {

      modal.hidden = true;

      if (trigger.isConnected) {

        trigger.focus({ preventScroll: true });

      }

      closeTimer = null;

    }, 290);

  };

  trigger.addEventListener('click', (event) => {

    event.preventDefault();

    event.stopPropagation();

    openModal();

  });

  closeButtons.forEach((button) => {

    button.addEventListener('click', closeModal);

  });

  modal.addEventListener('keydown', (event) => {

    if (event.key === 'Escape') {

      event.preventDefault();

      closeModal();

      return;

    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements();

    if (focusable.length === 0) return;

    const first = focusable[0];

    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {

      event.preventDefault();

      last.focus();

    } else if (!event.shiftKey && document.activeElement === last) {

      event.preventDefault();

      first.focus();

    }

  });

}

function initReturnInfoModal(root) {
  const modal = root.querySelector('[data-goodlot-return-modal]');
  const trigger = root.querySelector('[data-goodlot-return-open]');

  if (!modal || !trigger) return;

  const panel = modal.querySelector('[data-goodlot-return-panel]');
  const closeButtons = [...modal.querySelectorAll('[data-goodlot-return-close]')];

  let closeTimer = null;

  const getFocusableElements = () => {
    if (!panel) return [];

    return [
      ...panel.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
      ),
    ].filter((element) => !element.hidden && element.offsetParent !== null);
  };

  const openModal = () => {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('goodlot-return-modal-open');

    window.requestAnimationFrame(() => {
      modal.classList.add('is-open');

      window.requestAnimationFrame(() => {
        const focusable = getFocusableElements();
        (focusable[0] || panel)?.focus({ preventScroll: true });
      });
    });
  };

  const closeModal = () => {
    if (modal.hidden) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('goodlot-return-modal-open');

    closeTimer = window.setTimeout(() => {
      modal.hidden = true;

      if (trigger.isConnected) {
        trigger.focus({ preventScroll: true });
      }

      closeTimer = null;
    }, 290);
  };

  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    openModal();
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements();
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
}


function initProductDetailModal(root) {

  const modal = root.querySelector('[data-goodlot-detail-modal]');

  if (!modal) return;

  const panel = modal.querySelector('[data-goodlot-detail-panel]');

  const modalTitle = modal.querySelector('[data-goodlot-detail-title]');

  const openButtons = [...root.querySelectorAll('[data-goodlot-detail-open]')];

  const closeButtons = [...modal.querySelectorAll('[data-goodlot-detail-close]')];

  const contentPanels = [...modal.querySelectorAll('[data-goodlot-detail-content]')];

  const specSearch = modal.querySelector('[data-goodlot-spec-search]');

  const specRows = [...modal.querySelectorAll('[data-goodlot-spec-row]')];

  const specEmpty = modal.querySelector('[data-goodlot-spec-empty]');

  const faqToggles = [...modal.querySelectorAll('[data-goodlot-faq-toggle]')];

  let lastTrigger = null;

  let closeTimer = null;

  const resetSpecs = () => {

    if (!specSearch) return;

    specSearch.value = '';

    specRows.forEach((row) => {

      row.hidden = false;

    });

    if (specEmpty) {

      specEmpty.hidden = true;

    }

  };

  const closeAllFaqs = () => {

    faqToggles.forEach((toggle) => {

      toggle.setAttribute('aria-expanded', 'false');

      const faq = toggle.closest('.goodlot-detail-modal__faq');

      const answer = faq?.querySelector('[data-goodlot-faq-answer]');

      if (answer) {

        answer.hidden = true;

      }

    });

  };

  const showPanel = (key) => {

    contentPanels.forEach((content) => {

      content.hidden = content.dataset.goodlotDetailContent !== key;

    });

  };

  const getFocusableElements = () => {

    if (!panel) return [];

    return [

      ...panel.querySelectorAll(

        'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'

      ),

    ].filter((element) => !element.hidden && element.offsetParent !== null);

  };

  const openModal = (trigger) => {

    const key = trigger.dataset.goodlotDetailOpen;

    if (!key) return;

    if (closeTimer) {

      window.clearTimeout(closeTimer);

      closeTimer = null;

    }

    lastTrigger = trigger;

    resetSpecs();

    closeAllFaqs();

    showPanel(key);

    if (modalTitle) {

      modalTitle.textContent =

        trigger.dataset.goodlotDetailTitle || 'Product details';

    }

    modal.hidden = false;

    modal.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('goodlot-detail-modal-open');

    window.requestAnimationFrame(() => {

      modal.classList.add('is-open');

      window.requestAnimationFrame(() => {

        const focusable = getFocusableElements();

        (focusable[0] || panel)?.focus({ preventScroll: true });

      });

    });

  };

  const closeModal = () => {

    if (modal.hidden) return;

    modal.classList.remove('is-open');

    modal.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('goodlot-detail-modal-open');

    closeTimer = window.setTimeout(() => {

      modal.hidden = true;

      contentPanels.forEach((content) => {

        content.hidden = true;

      });

      resetSpecs();

      closeAllFaqs();

      if (lastTrigger?.isConnected) {

        lastTrigger.focus({ preventScroll: true });

      }

      lastTrigger = null;

      closeTimer = null;

    }, 290);

  };

  openButtons.forEach((button) => {

    button.addEventListener('click', () => openModal(button));

  });

  closeButtons.forEach((button) => {

    button.addEventListener('click', closeModal);

  });

  specSearch?.addEventListener('input', () => {

    const query = specSearch.value.trim().toLowerCase();

    let visibleCount = 0;

    specRows.forEach((row) => {

      const searchable = row.dataset.goodlotSpecSearchText || '';

      const isMatch = query === '' || searchable.includes(query);

      row.hidden = !isMatch;

      if (isMatch) {

        visibleCount += 1;

      }

    });

    if (specEmpty) {

      specEmpty.hidden = visibleCount !== 0;

    }

  });

  faqToggles.forEach((toggle) => {

    toggle.addEventListener('click', () => {

      const faq = toggle.closest('.goodlot-detail-modal__faq');

      const answer = faq?.querySelector('[data-goodlot-faq-answer]');

      if (!answer) return;

      const wasOpen = toggle.getAttribute('aria-expanded') === 'true';

      faqToggles.forEach((otherToggle) => {

        const otherFaq = otherToggle.closest('.goodlot-detail-modal__faq');

        const otherAnswer = otherFaq?.querySelector('[data-goodlot-faq-answer]');

        otherToggle.setAttribute('aria-expanded', 'false');

        if (otherAnswer) {

          otherAnswer.hidden = true;

        }

      });

      if (!wasOpen) {

        toggle.setAttribute('aria-expanded', 'true');

        answer.hidden = false;

      }

    });

  });

  modal.addEventListener('keydown', (event) => {

    if (event.key === 'Escape') {

      event.preventDefault();

      closeModal();

      return;

    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements();

    if (focusable.length === 0) return;

    const first = focusable[0];

    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {

      event.preventDefault();

      last.focus();

    } else if (!event.shiftKey && document.activeElement === last) {

      event.preventDefault();

      first.focus();

    }

  });

}

function initQuantity(root) {

  const quantityInput = root.querySelector('[data-goodlot-quantity-input]');

  const quantityValue = root.querySelector('[data-goodlot-quantity-value]');

  const minus = root.querySelector('[data-goodlot-quantity-minus]');

  const plus = root.querySelector('[data-goodlot-quantity-plus]');

  if (!quantityInput || !quantityValue || !minus || !plus) return;

  let quantity = Number(quantityInput.value) || 1;

  const syncQuantity = () => {

    quantityInput.value = String(quantity);

    quantityValue.textContent = String(quantity);

    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

  };

  minus.addEventListener('click', () => {

    quantity = Math.max(1, quantity - 1);

    syncQuantity();

  });

  plus.addEventListener('click', () => {

    quantity += 1;

    syncQuantity();

  });

}

function initWarrantyCarousel(root) {

  const section = root.querySelector('[data-goodlot-warranty-carousel]');

  if (!section || section.dataset.goodlotWarrantyInitialized === 'true') return;

  section.dataset.goodlotWarrantyInitialized = 'true';

  const track = section.querySelector('[data-goodlot-warranty-track]');

  const prevButton = section.querySelector('[data-goodlot-warranty-prev]');

  const nextButton = section.querySelector('[data-goodlot-warranty-next]');

  const cards = [...section.querySelectorAll('.goodlot-pdp__warranty-card')];

  if (!track || cards.length === 0) return;

  const getGap = () => {

    const styles = window.getComputedStyle(track);

    return Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;

  };

  const getStep = () => {

    const firstCard = cards[0];

    if (!firstCard) return track.clientWidth;

    return firstCard.getBoundingClientRect().width + getGap();

  };

  const updateButtons = () => {

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

    const left = track.scrollLeft;

    if (prevButton) prevButton.disabled = left <= 2;

    if (nextButton) nextButton.disabled = left >= maxScroll - 2;

  };

  const moveByCard = (direction) => {

    track.scrollBy({

      left: getStep() * direction,

      behavior: 'smooth',

    });

  };

  prevButton?.addEventListener('click', () => moveByCard(-1));

  nextButton?.addEventListener('click', () => moveByCard(1));

  track.addEventListener(

    'scroll',

    () => window.requestAnimationFrame(updateButtons),

    { passive: true }

  );

  track.addEventListener('keydown', (event) => {

    if (event.key === 'ArrowLeft') {

      event.preventDefault();

      moveByCard(-1);

    } else if (event.key === 'ArrowRight') {

      event.preventDefault();

      moveByCard(1);

    }

  });

  // Desktop mouse drag. Mobile keeps native touch scrolling/swiping.

  let dragging = false;

  let pointerId = null;

  let startX = 0;

  let startScrollLeft = 0;

  track.addEventListener('pointerdown', (event) => {

    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    if (event.target.closest('a, button')) return;

    dragging = true;

    pointerId = event.pointerId;

    startX = event.clientX;

    startScrollLeft = track.scrollLeft;

    track.classList.add('is-dragging');

    try {

      track.setPointerCapture(pointerId);

    } catch (_) {

      // Safe fallback.

    }

  });

  track.addEventListener('pointermove', (event) => {

    if (!dragging || event.pointerId !== pointerId) return;

    track.scrollLeft = startScrollLeft - (event.clientX - startX);

  });

  const finishDrag = (event) => {

    if (!dragging || event.pointerId !== pointerId) return;

    dragging = false;

    track.classList.remove('is-dragging');

    const step = getStep();

    if (step > 0) {

      const targetIndex = Math.round(track.scrollLeft / step);

      track.scrollTo({

        left: targetIndex * step,

        behavior: 'smooth',

      });

    }

    try {

      track.releasePointerCapture(pointerId);

    } catch (_) {

      // Safe fallback.

    }

    pointerId = null;

  };

  track.addEventListener('pointerup', finishDrag);

  track.addEventListener('pointercancel', finishDrag);

  if ('ResizeObserver' in window) {

    const resizeObserver = new ResizeObserver(updateButtons);

    resizeObserver.observe(track);

  } else {

    window.addEventListener('resize', updateButtons, { passive: true });

  }

  updateButtons();

}


function initShopPayInstallmentLayout(root) {
  const layout = root.querySelector('[data-goodlot-shop-pay-layout]');
  if (!layout || layout.dataset.goodlotShopPayInitialized === 'true') return;

  const amountOutput = layout.querySelector('[data-goodlot-shop-pay-amount]');
  const nativeWrap = layout.querySelector('[data-goodlot-shop-pay-native]');
  const paymentTerms =
    nativeWrap?.querySelector('shopify-payment-terms') ||
    layout.querySelector('shopify-payment-terms');
  const variantInput = layout.querySelector('[data-goodlot-shop-pay-variant-id]');

  if (!amountOutput || !paymentTerms) return;

  layout.dataset.goodlotShopPayInitialized = 'true';

  const extractMonthlyAmount = (value = '') => {
    const textValue = String(value).replace(/\s+/g, ' ').trim();

    const match =
      textValue.match(/from\s+([$€£]\s?[\d,.]+(?:\.\d{1,2})?)\s*\/\s*mo\.?/i) ||
      textValue.match(/([$€£]\s?[\d,.]+(?:\.\d{1,2})?)\s*\/\s*mo\.?/i);

    if (!match?.[1]) return '';

    return `${match[1].replace(/\s+/g, '')}/mo.`;
  };

  const getPaymentTermsText = () => {
    const values = [];

    if (paymentTerms.shadowRoot?.textContent) {
      values.push(paymentTerms.shadowRoot.textContent);
    }

    if (paymentTerms.textContent) {
      values.push(paymentTerms.textContent);
    }

    return values.join(' ');
  };

  const updateAmount = () => {
    const amount = extractMonthlyAmount(getPaymentTermsText());

    if (!amount) return false;

    amountOutput.textContent = amount;
    amountOutput.hidden = false;
    return true;
  };

  let shadowObserver = null;

  const observeShadowRoot = () => {
    const shadowRoot = paymentTerms.shadowRoot;
    if (!shadowRoot || shadowObserver) return;

    shadowObserver = new MutationObserver(() => {
      window.requestAnimationFrame(updateAmount);
    });

    shadowObserver.observe(shadowRoot, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    updateAmount();
  };

  const hostObserver = new MutationObserver(() => {
    observeShadowRoot();
    window.requestAnimationFrame(updateAmount);
  });

  hostObserver.observe(paymentTerms, {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true,
  });

  if (variantInput) {
    variantInput.addEventListener('change', () => {
      amountOutput.hidden = true;

      window.setTimeout(() => {
        observeShadowRoot();
        updateAmount();
      }, 60);

      window.setTimeout(updateAmount, 220);
      window.setTimeout(updateAmount, 600);
    });
  }

  let attempts = 0;

  const waitForTerms = () => {
    attempts += 1;

    observeShadowRoot();

    if (updateAmount() || attempts >= 80) return;

    window.setTimeout(waitForTerms, 100);
  };

  waitForTerms();
}


function initGoodLotProduct(root) {

  if (!root || root.dataset.goodlotProductInitialized === 'true') return;

  root.dataset.goodlotProductInitialized = 'true';

  initGallery(root);

  initSourceInfoModal(root);

  initInspectionRecordModal(root);

  initReturnInfoModal(root);

  initProductDetailModal(root);

  initQuantity(root);

  initWarrantyCarousel(root);

  initShopPayInstallmentLayout(root);

  updateDeliveryEstimate(root);

}

function initAllGoodLotProducts(scope = document) {

  if (scope.matches?.('[data-goodlot-product-main]')) {

    initGoodLotProduct(scope);

  }

  scope

    .querySelectorAll?.('[data-goodlot-product-main]')

    .forEach(initGoodLotProduct);

}

if (document.readyState === 'loading') {

  document.addEventListener(

    'DOMContentLoaded',

    () => initAllGoodLotProducts(document),

    { once: true }

  );

} else {

  initAllGoodLotProducts(document);

}

document.addEventListener('shopify:section:load', (event) => {

  initAllGoodLotProducts(event.target);

});